import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FormGroup, Input, Button } from "reactstrap";
import { connect } from "react-redux";
import {
  NotificationManager,
  NotificationContainer
} from "react-notifications";
import Logo from "assets/images/logo.jpg";

import { LOGIN_USER } from "constants/actionTypes";
import { createUnrestrictedAction } from "util/actionCreators";

import IntlMessages from "util/IntlMessages";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: ""
    };
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit() {
    this.props.createUnrestrictedAction(
      "jwt",
      LOGIN_USER,
      "POST",
      { data: this.state },
      response => {
        window.localStorage.setItem("token", response.data.access_token);
        window.localStorage.setItem("is_owner", response.data.is_owner);
        window.localStorage.setItem("cc_email", response.data.cc_email);
        window.localStorage.setItem("name", response.data.name);
        window.localStorage.setItem("email", response.data.email);
        window.localStorage.setItem("id", response.data.id);
        this.props.history.push("/");
        return NotificationManager.success(response.message, "", 3000);
      }
    );
  }

  render() {
    const { email, password } = this.state;
    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="login-content">
          <div className="login-header mb-4 text-center">
            <Link className="app-logo" to="/" title="Majocchi Listino">
              <img src={Logo} alt="majocchi" title="majocchi" />
            </Link>
          </div>

          <div className="login-form">
            <div>
              <FormGroup className="mb-4">
                <Input
                  type="email"
                  name="email"
                  value={email}
                  placeholder="Email"
                  onChange={this.handleChange.bind(this)}
                />
              </FormGroup>
              <FormGroup className="mb-4">
                <Input
                  type="password"
                  name="password"
                  value={password}
                  placeholder="Password"
                  onChange={this.handleChange.bind(this)}
                />
              </FormGroup>
              <div className="mt-1 mb-2 d-flex justify-content-between align-items-center">
                {/* <Link to='/forgot-password' title='Reset Password'>
                  <IntlMessages id='appModule.forgotPassword' />
                </Link> */}
                <Link to="/register" title="Create Account">
                  Create Account
                </Link>
                <Button
                  className="btn btn-primary"
                  onClick={this.handleSubmit.bind(this)}
                >
                  Login
                </Button>
              </div>
            </div>
          </div>
          <NotificationContainer />
        </div>
      </div>
    );
  }
}

export default connect(null, { createUnrestrictedAction })(Login);



// WEBPACK FOOTER //
// ./containers/Login.js